import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { ClickTarget, click } from '@tracking';

import { TextButton } from '../Button/variants';

const COOKIES_SETTINGS_TEXT = 'Cookies Settings';
const HYDRATED_COOKIES_SETTINGS_TEXT = 'Do Not Sell or Share My Personal Info';

const CookiesSettingsBtn = () => {
  const hydrated = useServerSideRendering();
  const { trackEvent } = useEventTracking();

  return (
    <div>
      <TextButton
        id="ot-sdk-btn"
        className={clsx(
          'ot-sdk-show-settings !mt-8 !w-auto cursor-pointer !justify-start !border-none !bg-transparent !p-0 !font-suisse-screen text-overline-md !text-grayscale-beige !no-underline !opacity-50 !transition-all hover:!text-primary-magenta hover:!opacity-100 focus:!text-primary-magenta',
          'dark:!text-white dark:hover:!text-primary-pink'
        )}
        as="link"
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.DoNotSell }))}
      >
        {hydrated ? HYDRATED_COOKIES_SETTINGS_TEXT : COOKIES_SETTINGS_TEXT}
      </TextButton>
    </div>
  );
};

export default CookiesSettingsBtn;
